import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TooltipOptionItem, TooltipOptionListItem } from '@luigiclaudio/ga-baseline-ui/tooltip';
import { ThemeContext } from 'styled-components';
import { useIntl } from 'react-intl';
import colorToolsUtils from '../../utils/colorToolsUtils';
import handleOnColorClick from '../../utils/handleOnColorClick';
import useAllColorUserCache from '../../services/useAllColorUserCache';
import FeedbackContext from '../feedbackContext/FeedbackContext';
import feedbackOnStageUtils from '../../utils/feedbackOnStageUtils';

const ColorTooltipOptionFavorite = ({ colorValue, hideTooltip, showAddToFavorites }) => {
    if (!showAddToFavorites) {
        return false;
    }

    const intl = useIntl();
    const { setFeedbackOnStage } = useContext(FeedbackContext);
    const theme = useContext(ThemeContext);

    const {
        allColorsUserFromClient,
        setAllColorsUserFromClient,
        createColor,
        deleteColor,
        user,
        pathname,
        client,
    } = useAllColorUserCache(
        () => setFeedbackOnStage(feedbackOnStageUtils.colorAddedToLibrary(colorValue, theme, intl)),
        () =>
            setFeedbackOnStage(
                feedbackOnStageUtils.colorRemovedFromLibrary(colorValue, theme, intl),
            ),
    );

    const isFavorite = allColorsUserFromClient?.allColors?.data?.find(
        (item) => item.color === colorValue,
    );

    const { colorLibraryLabel, colorLibraryIcon } = colorToolsUtils.colorInLibraryLabel(
        isFavorite,
        theme,
        intl,
        user,
    );

    return (
        <TooltipOptionListItem>
            <TooltipOptionItem
                label={colorLibraryLabel}
                icon={colorLibraryIcon}
                onClick={() => {
                    handleOnColorClick({
                        currentColor: colorValue,
                        currentId: isFavorite?.id,
                        setAllColorsUserFromClient,
                        allColorsUserFromClient,
                        client,
                        createColor,
                        deleteColor,
                        user,
                        pathname,
                    });
                    hideTooltip();
                }}
            />
        </TooltipOptionListItem>
    );
};

ColorTooltipOptionFavorite.propTypes = {
    colorValue: PropTypes.string.isRequired,
    hideTooltip: PropTypes.func,
    showAddToFavorites: PropTypes.bool,
};

ColorTooltipOptionFavorite.defaultProps = {
    hideTooltip: () => {},
    showAddToFavorites: false,
};

export default ColorTooltipOptionFavorite;
